import * as R from 'ramda'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const getCountriesActions = generateActions('countries/GET')

export const getCountries = createAction(
  API_CONST,
  () => ({
    actions: getCountriesActions,
    url: 'countries'
  })
)

const initialState = {}

export default handleActions({
  [getCountriesActions[1]]: (state, { payload = [] }) => ({
    ...state,
    ...payload.reduce((acc, item) => R.assoc(item.countryId, item, acc), {})
  })
}, initialState)



// WEBPACK FOOTER //
// ./src/store/reducers/countries/index.js